import {
	ACCOUNT_RECOVER,
	ACTION_REQUEST,
	ACTION_REQUEST_END,
	AUTH_RESET,
	GET_PACKAGES,
	GET_USER,
	GOOGLE_FULL_SIGNUP_SUCCESS,
	GOOGLE_SIGNUP_SUCCESS,
	LOGIN_FAIL,
	LOGIN_SUCCESS,
	LOGOUT_SUCCESS,
	PHONE_UPDATE_END,
	PHONE_UPDATE_SUCCESS,
	PHONE_VERIFIED,
	PHONE_VERIFIED_END,
	REGISTER_COMPLETE,
	REGISTER_FAIL,
	REGISTER_SUCCESS,
	SET_DELIVERY_LOADING,
} from '../actions/types';

const initState = {
	authError: '',
	uid: '',
	firtSignIn: false,
	imageLoading: false,
	passwordLoading: false,
	requested: false,
	registered: false,
	google_registered: false,
	user: null,
	verified: false,
	products: null,
	prices: null,
	phone: null,
	phoneUpdate: false,
	temp_user: null,
	delivery_loading: false,
	card_details: {},
};

const authReducer = (state = initState, action) => {
	switch (action.type) {
		case LOGIN_SUCCESS:
			return {
				...state,
				uid: action.user.id,
				user: action.user,
				authError: '',
			};
		case 'GET_CARD_DETAILS':
			return {
				...state,
				card_details: action.payload,
			};
		case 'IMAGE_LOADING':
			return {
				...state,
				imageLoading: action.payload,
			};
		case 'FIRST_SIGN_IN':
			return { ...state, firstSignIn: true };
		case 'RESET_SIGN_IN':
			return { ...state, firstSignIn: false };
		case 'RESET_PASSWORD_LOADER':
			return {
				...state,
				passwordLoading: action.payload,
			};
		case GOOGLE_FULL_SIGNUP_SUCCESS:
			return {
				...state,
				temp_user: null,
				registered: true,
				google_registered: false,
			};

		case GOOGLE_SIGNUP_SUCCESS:
			return {
				...state,
				temp_user: { ...action.user },
				google_registered: true,
				authError: '',
			};
		case LOGIN_FAIL:
			return {
				...state,
				uid: '',
				authError: action.error.message,
			};
		case REGISTER_SUCCESS:
			return {
				...state,
				uid: '',
				authError: '',
				registered: true,
				google_registered: false,
			};
		case ACCOUNT_RECOVER:
			return {
				...state,
				uid: '',
				authError: '',
				registered: true,
			};

		case REGISTER_FAIL:
			return {
				...state,
				uid: '',
			};
		case REGISTER_COMPLETE:
			return {
				...state,
				registered: false,
				google_registered: false,
			};
		case SET_DELIVERY_LOADING:
			return {
				...state,
				delivery_loading: action.payload,
			};
		case LOGOUT_SUCCESS:
			localStorage.clear();
			return {
				...state,
				authError: '',
				uid: '',
			};
		case AUTH_RESET:
			return {
				...state,
				authError: '',
			};
		case GET_USER:
			return {
				...state,
				user: action.user,
			};
		case ACTION_REQUEST:
			return {
				...state,
				requested: true,
			};
		case ACTION_REQUEST_END:
			return {
				...state,
				requested: false,
			};
		case PHONE_UPDATE_SUCCESS:
			return {
				...state,
				phoneUpdate: true,
			};
		case PHONE_UPDATE_END:
			return {
				...state,
				phoneUpdate: false,
			};

		case PHONE_VERIFIED:
			return {
				...state,
				verified: true,
				phone: action.phone,
			};
		case PHONE_VERIFIED_END:
			return {
				...state,
				verified: false,
			};
		case GET_PACKAGES:
			return {
				...state,
				products: action.products,
				prices: action.prices,
			};

		default:
			return state;
	}
};

export default authReducer;
